module.exports = __webpack_public_path__ + "static/media/WA3F2100.03dc5f39.svg";